module.exports = __webpack_public_path__ + "img/qrcode_contact.32a2cb5a.png";